module.exports = "/packs/multicreatorcourse-logo-white-add2d5f8eb35dfc559f48d8aed7b2c79.svg";